// extracted by mini-css-extract-plugin
export default {"form-container":"SignUp_form-container__6wEvk","image-container":"SignUp_image-container__n5f+t"};